import { render, staticRenderFns } from "./MarketingStory.vue?vue&type=template&id=3830f8a0&"
import script from "./MarketingStory.vue?vue&type=script&lang=js&"
export * from "./MarketingStory.vue?vue&type=script&lang=js&"
import style0 from "./MarketingStory.vue?vue&type=style&index=0&id=3830f8a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports